import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { LocatorSummaryStatsService } from 'src/app/locator/services/locator-summary-stats.service';
import { LocatorSummaryStatsStatus } from 'src/app/locator/models/locator-summary-stats-status';
import { LocatorSummaryStatsStatusTypes } from 'src/app/locator/helpers/locator-status-helper';
import { ConsoleLogService } from 'src/app/shared/services/console-log.service';

@Component({
  selector: 'atlas-summary-stats-loading',
  templateUrl: './summary-stats-loading.component.html',
  styleUrls: ['./summary-stats-loading.component.less'],
  standalone: false
})
export class SummaryStatsLoadingComponent implements OnInit, OnDestroy {
  @Input() libraryId: number;
  @Output() loadingComplete = new EventEmitter<void>();
  @Output() loadingError = new EventEmitter<void>();

  summaryStatsStatus: LocatorSummaryStatsStatusTypes | null = null;
  hasError = false;

  private destroy$ = new Subject<void>();

  constructor(
    private locatorSummaryStatsService: LocatorSummaryStatsService,
    private logService: ConsoleLogService
  ) { }

  ngOnInit(): void {
    this.startSummaryStatsGeneration();
  }

  private startSummaryStatsGeneration(): void {
    this.hasError = false;
    
    // First trigger the creation of summary stats, then poll for status
    this.locatorSummaryStatsService
      .createLocatorLibrarySummaryStats(this.libraryId)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: () => {
          this.pollForStatus();
        },
        error: (error) => {
          this.logService.log('Error creating summary stats:', error);
          this.hasError = true;
          this.loadingError.emit();
        }
      });
  }

  private pollForStatus(): void {
    this.locatorSummaryStatsService
      .pollForLocatorLibrarySummaryStatsStatus(this.libraryId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (statusResponse: LocatorSummaryStatsStatus) => {
          this.summaryStatsStatus = statusResponse.status;
          
          if (statusResponse.status === 'SummaryStatsCompleted') {
            this.loadingComplete.emit();
          } 
          else if (statusResponse.errorMessage) {
            this.hasError = true;
            this.loadingError.emit();
          }
        },
        error: (error) => {
          this.logService.log('Error polling summary stats status:', error);
          this.hasError = true;
          this.loadingError.emit();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
